import React from "react";
import ChangeAlbeHeader from "./ChangeAbleHeader";
import "../components/componentstyle/contact.css";

function Contact() {
  return (
    <>
      <div>
        <ChangeAlbeHeader>Contact Us</ChangeAlbeHeader>
      </div>

      <div className="contact-container container">
        <div className="contact-left">
          <h3>Head Office</h3>
          <p>
            Lorem Ipsum is simply dummy text ,<br />
            Industry-560016.
          </p>

          <h3>Contact Info</h3>
          <p>+91 7096000699</p>
          <p> +91 9712020601 </p>
          <p>+91 9558366896 </p>

          <h3>Email Info</h3>
          <p> jmcdist.surat@gmail.com</p>
        </div>

        <div className="contact-right">
          <h2>GET IN TOUCH</h2>
          <form action="https://formspree.io/f/mjkrwzwa" method="post">
            <div className="form-row">
              <input type="text" placeholder="Full Name" name="name" required />
              <input
                type="email"
                placeholder="Email Id"
                name="email"
                required
              />
            </div>
            <div className="form-row">
              <input type="text" placeholder="Mobile" name="mobile" required />
              <input
                type="text"
                placeholder="Subject"
                name="subject"
                required
              />
            </div>
            <textarea placeholder="Message" name="message"></textarea>
            {/* <button type="submit">Submit</button> */}
            <input type="submit" value="Submit" className="button" />
          </form>
        </div>
      </div>

      <div className="map-container container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.9314044868415!2d72.86648908515981!3d21.234568530328996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f463f8bae07%3A0xfd989c452e035e5f!2sRJSQUARE%20INFOTECH!5e0!3m2!1sen!2sin!4v1747805068925!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
          title="map"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </>
  );
}

export default Contact;
